<template>
  <CRow>
    <CCol sm="12">
      <div class="d-flex justify-content-center align-items-center">
        <CSpinner color="custom-color" :style="getSize(size)" />
      </div>
    </CCol>
  </CRow>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'md',
    },
  },
  data() {
    return {
      sizeList: {
        sm: { width: '2rem', height: '2rem' },
        md: { width: '4rem', height: '4rem' },
        lg: { width: '6rem', height: '6rem' },
      },
    }
  },
  methods: {
    getSize(size) {
      return this.sizeList[size] || this.sizeList['md']
    },
  },
}
</script>
